import React from "react";
import { motion } from "framer-motion";
import {
  FaShieldAlt,
  FaVideo,
  FaIdCard,
  FaUserShield,
} from "react-icons/fa";

const Security = () => {
  const features = [
    {
      icon: <FaShieldAlt />,
      title: "Professional Security",
      desc: "Our campus is protected by trained and experienced security personnel throughout the school day.",
    },
    {
      icon: <FaVideo />,
      title: "CCTV Surveillance",
      desc: "The entire campus is monitored through CCTV cameras to ensure continuous safety and supervision.",
    },
    {
      icon: <FaIdCard />,
      title: "ID Card Entry",
      desc: "Students, staff and authorised personnel enter the campus only through valid identity cards.",
    },
    {
      icon: <FaUserShield />,
      title: "Visitor Management",
      desc: "Entry of visitors is strictly regulated to maintain a secure and disciplined school environment.",
    },
  ];

  return (
    <section className="bg-white py-20">

      <div className="max-w-[1400px] mx-auto px-6">

        {/* Heading */}

        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: .7 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >

          <p className="uppercase tracking-[6px] text-[#d4af37] font-bold mb-4">

            Cambridge International School

          </p>

          <h1 className="text-5xl md:text-6xl font-black text-[#07294d]">

            Safety & Security

          </h1>

          <div className="w-24 h-1 rounded-full bg-[#d4af37] mx-auto mt-6 mb-8"></div>

          <p className="max-w-3xl mx-auto text-lg text-gray-600 leading-9">

            Cambridge International School, Nakodar gives utmost priority
            to the safety and security of every student. We strive to
            provide a safe, disciplined and secure environment where
            children can learn with confidence.

          </p>

        </motion.div>

        {/* Content */}

        <motion.div
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: .7 }}
          viewport={{ once: true }}
          className="bg-[#f8fafc] rounded-[30px] p-10 lg:p-14 border border-gray-100 shadow-lg mb-20"
        >

          <span className="uppercase tracking-[5px] text-[#d4af37] font-bold">

            Secure Learning Environment

          </span>

          <h2 className="text-4xl md:text-5xl font-black text-[#07294d] mt-5 mb-8">

            Student Safety
            <br />

            Is Our Highest Priority

          </h2>

          <p className="text-gray-600 text-lg leading-9 mb-6">

            The school campus is fully secured and guarded by professional
            security personnel. Every corner of the campus remains under
            CCTV surveillance to ensure the safety of students, staff and
            visitors at all times.

          </p>

          <p className="text-gray-600 text-lg leading-9">

            Special attention is given during student arrival and dispersal.
            Entry to the campus is permitted only through valid Identity
            Cards, while unauthorised visitors are strictly prohibited,
            creating a secure and disciplined learning environment.

          </p>

        </motion.div>

        {/* Feature Cards */}

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">

          {features.map((item, index) => (

            <motion.div
              key={index}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: .6,
                delay: index * .1,
              }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              className="bg-white border border-gray-100 rounded-[28px] shadow-lg p-8"
            >

              <div className="w-16 h-16 rounded-2xl bg-[#07294d] text-white flex items-center justify-center text-3xl mb-6">

                {item.icon}

              </div>

              <h3 className="text-2xl font-bold text-[#07294d] mb-4">

                {item.title}

              </h3>

              <div className="w-12 h-1 rounded-full bg-[#d4af37] mb-5"></div>

              <p className="text-gray-600 leading-8">

                {item.desc}

              </p>

            </motion.div>

          ))}

        </div>
                {/* Bottom Note */}

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="mt-20 bg-[#07294d] rounded-[30px] px-10 py-14 text-center"
        >

          <div className="max-w-4xl mx-auto">

            <div className="w-20 h-20 rounded-full bg-[#d4af37] mx-auto flex items-center justify-center text-white text-4xl mb-8">

              <FaShieldAlt />

            </div>

            <h2 className="text-4xl md:text-5xl font-black text-white mb-6">

              A Safe Campus for Every Child

            </h2>

            <p className="text-gray-300 text-lg leading-9">

              We believe that a secure environment is essential for
              quality education. Through professional security staff,
              continuous CCTV surveillance, strict identity verification
              and regulated visitor access, Cambridge International
              School ensures that every student enjoys a safe, disciplined
              and peaceful learning experience every day.

            </p>

          </div>

        </motion.div>

      </div>

    </section>
  );
};

export default Security;